import { Nav, Footer } from "../components/Nav";

import meImg from "../images/Me.png";
// import danceImg from "../images/Dance.png";
export default function Portfolio() {
  return (
    <>
      <Nav color="white" />
      <main className="about-container black-bg white-text">
        <section id="about-section">
          <h2 style={{ marginTop: "0" }}>About Me</h2>
          <p>
            Hi there! My name is Mandy (Tsaichen) Lin and I'm currently pursuing
            a Master's in Human-Computer Interaction @ Georgia Institute of
            Technology. Previously I studied Computer Science and Graphic Design
            @ Santa Clara University (2021-2024) and interned at Trimble as a UI
            Engineer (Summer 2025).
          </p>
          <p>
            My interest lies in UX and Product Design, particularly in bridging
            design and technology to create meaningful experiences.
          </p>
          <img src={meImg} alt="Photos of Mandy Lin" />
          <h2>If I'm not designing or coding, I'm probably...</h2>
          <ul>
            <li>Crocheting</li>
            <li>Cooking</li>
            <li>Dancing</li>
            <li>Trying new food spots</li>
          </ul>
        </section>
      </main>

      <Footer />
    </>
  );
}
